import React from 'react';

import { CmAccordionPanel, CmText } from '@/components/uiParts';

import { AccordionLink } from './AccordionLinkButton';
import { ChildList } from './sidebarList';

type Props = {
  childPageList: ChildList[];
};

export const AccordionPanel: React.VFC<Props> = ({ childPageList }) => {
  return (
    <CmAccordionPanel pb={2} pr={0} pl={0}>
      {childPageList.map((childPage, index) => {
        return (
          <AccordionLink
            key={index}
            to={childPage.path}
            isDisabled={childPage.isDisabled}
            isCurrentPage={location.pathname.includes(childPage.path)}
          >
            <CmText
              color={childPage.isDisabled ? 'gray.400' : 'white'}
              align="center"
              p={1}
              pl={4}
            >
              {childPage.title}
            </CmText>
          </AccordionLink>
        );
      })}
    </CmAccordionPanel>
  );
};
